module.exports = __webpack_public_path__ + "static/img/img5.11ed710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/puzzleImg/img5.jpg
// module id = SB89
// module chunks = 1